import { IconProps } from ".";

export const WorkflowFolderIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33341 3.83333C3.33341 2.82081 4.15423 2 5.16675 2H7.4478C7.93403 2 8.40034 2.19315 8.74416 2.53697L9.29644 3.08926C9.45272 3.24554 9.66469 3.33333 9.8857 3.33333H13.5001C14.5126 3.33333 15.3334 4.15414 15.3334 5.16667V9.5C15.3334 10.5125 14.5126 11.3333 13.5001 11.3333H12.6667V12.1667C12.6667 13.1792 11.8459 14 10.8334 14H2.50008C1.48756 14 0.666748 13.1792 0.666748 12.1667V6.5C0.666748 5.48748 1.48756 4.66667 2.50008 4.66667H3.33341V3.83333ZM2.50008 5.66667C2.03984 5.66667 1.66675 6.03976 1.66675 6.5V12.1667C1.66675 12.6269 2.03984 13 2.50008 13H10.8334C11.2937 13 11.6667 12.6269 11.6667 12.1667V7.83333C11.6667 7.3731 11.2937 7 10.8334 7H7.21903C6.7328 7 6.26649 6.80685 5.92267 6.46303L5.37039 5.91074C5.21411 5.75446 5.00214 5.66667 4.78113 5.66667H2.50008ZM4.33341 4.66667V3.83333C4.33341 3.3731 4.70651 3 5.16675 3H7.4478C7.66881 3 7.88077 3.0878 8.03705 3.24408L8.58934 3.79636C8.93315 4.14018 9.39947 4.33333 9.8857 4.33333H13.5001C13.9603 4.33333 14.3334 4.70643 14.3334 5.16667V9.5C14.3334 9.96024 13.9603 10.3333 13.5001 10.3333H12.6667V7.83333C12.6667 6.82081 11.8459 6 10.8334 6H7.21903C6.99802 6 6.78606 5.9122 6.62978 5.75592L6.07749 5.20364C5.73368 4.85982 5.26736 4.66667 4.78113 4.66667H4.33341Z"
        fill="currentColor"
        style={{
          fill: "color(display-p3 0.6000 0.6000 0.6000)",
          fillOpacity: "1"
        }}
      />
    </svg>
  );
};
